import http from '../../../api/httpClient';

export const INCIDENT_TYPES = [
    "Vehicle Breakdown",
    "Accident",
    "Financer Detention",
    "RTO Detention",
    "Police Detention",
    "E-Way Bill Issue",
    "Strike",
    "Natural Calamity",
] as const;

export type IncidentType = typeof INCIDENT_TYPES[number];

export interface IncidentDocumentPayload {
    document_type?: string;
    mime_type?: string;
    file_name?: string;
    file_base64: string;
}

export interface IncidentCreatePayload extends Record<string, unknown> {
    cn_number: string;
    incident_date: string;
    incident_type: string;
    lat?: number;
    lon?: number;
    address?: string;
    notes?: string;
    documents?: IncidentDocumentPayload[];
}

export interface IncidentCreateResponse {
    message: string;
}


export const createIncident = async (payload: IncidentCreatePayload): Promise<IncidentCreateResponse> => {
    try {
        return await http.post<IncidentCreateResponse>(`/api/v1/cto/incident/create`, payload);
    } catch (error) {
        console.error("Error creating incident:", error);
        throw error;
    }
};



export interface IncidentDocumentItem {
  id: number;
  document_type?: string;
  mime_type?: string;
  file_name?: string;
  uploaded_by: string;
  created_at: string;
}

export interface IncidentNoteItem {
  name: string;
  notes: string;
  created_at: string;
}

export interface IncidentItem {
  id: number;
  cn_number: string;
  incident_date: string;
  incident_type: string;
  lat?: number;
  lon?: number;
  address?: string;
  created_by: string;
  created_at: string;
}

export interface CnIncidentResponse {
  incident: IncidentItem;
  notes: IncidentNoteItem[];
  documents: IncidentDocumentItem[];
}

export const getIncidentByCn = async (
  cnNumber: string
): Promise<CnIncidentResponse> => {
  try {
    return await http.get<CnIncidentResponse>(`/api/v1/cto/incident/${cnNumber}`);
  } catch (error) {
    console.error("Error fetching incident:", error);
    throw error;
  }
};



export interface IncidentUpdatePayload extends Record<string, unknown> {
  incident_id: number;
  notes?: string[];
  documents?: IncidentDocumentPayload[];
}

export interface IncidentUpdateResponse {
  incident_id: number;
  message: string;
}

export const updateIncident = async (
  payload: IncidentUpdatePayload
): Promise<IncidentUpdateResponse> => {
  try {
    return await http.put<IncidentUpdateResponse>(`/api/v1/cto/incident/update/${payload.incident_id}`, payload);
  } catch (error) {
    console.error("Error updating incident:", error);
    throw error;
  }
};


export const getIncidentDocument = async (documentId: number): Promise<Blob> => {
  try {
    const response = await http.get<Blob>(`/api/v1/cto/incident/get-document/${documentId}`, {responseType: "blob"});
    return response;
  } catch (error) {
    console.error("Error fetching incident document:", error);
    throw error;
  }
};